import helpers from '../helpers';

function init() {
	helpers.$window.on('scroll', () => {
		const scrollBarHeight = $('.main__scrollBar').height();
		const scrollBarTrackHeight = $('.main__scrollBarTrack').height();
		const Y = window.pageYOffset / ($(document).outerHeight() - window.innerHeight) * 100;
		const heightTop = Y > 98 ? 118 : Y + scrollBarTrackHeight;
		const heightBottom = scrollBarHeight - heightTop + scrollBarTrackHeight;
		gsap.to('.main__scrollBarTrack', {
			y: Y > 98 ? 98 : Y,
		});
		gsap.to('.main__scrollBarTrackTop', {
			height: heightTop,
		});
		gsap.to('.main__scrollBarTrackBottom', {
			height: heightBottom,
		});
	});

	const scrollBarHeight = $('.main__scrollBar').height();
	const scrollBarTrackHeight = $('.main__scrollBarTrack').height();
	const Y = scrollBarTrackHeight * window.pageYOffset / 100;
	const heightTop = Y > 98 ? 118 : Y + scrollBarTrackHeight;
	const heightBottom = scrollBarHeight - heightTop + scrollBarTrackHeight;
	gsap.to('.main__scrollBarTrack', {
		y: Y > 98 ? 98 : Y,
	});
	gsap.to('.main__scrollBarTrackTop', {
		height: heightTop,
	});
	gsap.to('.main__scrollBarTrackBottom', {
		height: heightBottom,
	});
}

export default {
	init,
};
